export default "__VITE_ASSET__D0XOh$oe__"